import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { fadeSlideAnimation } from './../../../../../assets/animations/fade-slide.animation';
import { environment } from './../../../../../environments/environment';
import { IProductos, T_TipoPromocion } from './../../../../private/shared/models/productos';

@Component({
  selector: 'getm-promo-product-row',
  templateUrl: './promo-product-row.component.html',
  styleUrls: ['./promo-product-row.component.scss'],
  animations: [fadeSlideAnimation]
})
export class PromoProductRowComponent implements OnInit {

  @Input() productosPromocion: IProductos[] = [];
  @Input() maximo: number | undefined = undefined;
  @Input() disabled: boolean = false;
  @Input() tipoPromocion: T_TipoPromocion | undefined;

  @Output() quantityChange = new EventEmitter<IProductos[]>();

  public isSKUFactorCl = environment.production;

  constructor() { }

  ngOnInit() { }

  public trackByProduct = (index: number, product: IProductos): string => product.clave_producto + '_' + product.ClavePromo + '_' + product.Nivel;

  public onQuantityChange = (product: IProductos, quantity: number): void => {
    this.quantityChange.emit(
      this.productosPromocion.map((p) => {
        if (p.clave_producto === product.clave_producto && p.ClavePromo === product.ClavePromo && p.Nivel === product.Nivel) {
          return { ...p, productos: quantity };
        }
        return p;
      })
    );
  };

  public onRemoveProduct = (product: IProductos): void => {
    this.quantityChange.emit(
      this.productosPromocion.map((p) => {
        if (p.clave_producto === product.clave_producto && p.ClavePromo === product.ClavePromo && p.Nivel === product.Nivel) {
          return { ...p, productos: 0 };
        }
        return p;
      })
    );
  };

}
